import { action, computed, makeObservable, observable } from "mobx";
import URLConstants from "../../constants/url-constants";
import { IObservableInitialState } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import * as baseService from "../service/base-service";
import { DATE_FORMAT, formatNumberWithCommas } from "../../constants/constants";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import { getLanguageFromLocalStorage } from "../../helpers/localstorage-helper";
import inventorySalePurchaseEnum from "../../constants/enums/inventory-sale-purchase-enum";
import dayjs from "dayjs";
import { IAppointmentAccToDate, IProjectedSalesCount } from "../../models/response/IDashboardResponse";

export class DashboardStore {
  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };
  dailyAppointmentDataList : IAppointmentAccToDate[] = [];
  dailyAppointmentDataListState : IObservableInitialState = {...this.initialStateValue};
  dailyProjectedSalesCount: IProjectedSalesCount[] = [];
  dailyProjectedSalesCountState : IObservableInitialState = {...this.initialStateValue};


  constructor() {
    makeObservable(this, {
      initialStateValue: observable,
      dailyAppointmentDataList: observable,
      dailyProjectedSalesCount: observable,
      dailyAppointmentDataListState: observable,
      dailyProjectedSalesCountState: observable,
      GetDailyAppointmentDataListService: action,
      GetDailyProjectedSalesCountService: action,
      getDailyProjectedSalesCount: computed,
      resetDailyProjectedSalesCountState: action,
      resetDailyAppointmentDataListState: action,
    });
  }

  GetDailyAppointmentDataListService = (
    storeId: number,
    headquarterId: number,
  ) => {    
    this.dailyAppointmentDataListState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    const url =
      URLConstants.GetDashboardDailyAppointmentDataList + "?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IAppointmentAccToDate[]>>) => {
          if (response.data.Error) {
            this.dailyAppointmentDataListState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.dailyAppointmentDataList = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.dailyAppointmentDataListState.error = err;
      })
      .finally(
        action(() => {
          this.dailyAppointmentDataListState.inProgress = false;
        })
      );
  };

  resetDailyAppointmentDataListState = () =>{
    this.dailyAppointmentDataListState = {...this.initialStateValue};
  }
  
  GetDailyProjectedSalesCountService = (
    storeId: number,
    headquarterId: number,
  ) => {    
    this.dailyProjectedSalesCountState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    const url =
      URLConstants.GetDashboardDailyProjectedSalesCount + "?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IProjectedSalesCount[]>>) => {
          if (response.data.Error) {
            this.dailyProjectedSalesCountState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.dailyProjectedSalesCount = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.dailyProjectedSalesCountState.error = err;
      })
      .finally(
        action(() => {
          this.dailyProjectedSalesCountState.inProgress = false;
        })
      );
  };

  resetDailyProjectedSalesCountState = () =>{
    this.dailyProjectedSalesCountState = {...this.initialStateValue};
  }

  get getDailyProjectedSalesCount(): IProjectedSalesCount {
    let tempProjectSales: IProjectedSalesCount = {
        AppointmentDate: "",
        ProjectedAmount: 0,
        ProjectedCount: 0,
        RecordedAmount: 0,
        RecordedCount: 0,  
    }
    if(this.dailyProjectedSalesCount.length > 0){
        tempProjectSales = {...this.dailyProjectedSalesCount[0]}
    }
    return tempProjectSales;
  }
  
}

export default new DashboardStore();
